/* Coco Bamboo landing — shared behaviour (reveal-on-scroll, sticky CTA). Safe to load once per page. */
(function () {
  if (window.__cbLandingInit) { window.__cbLandingRefresh && window.__cbLandingRefresh(); return; }
  window.__cbLandingInit = true;

  var revealIO = null, heroIO = null;

  function setupReveal() {
    var els = document.querySelectorAll('.cb-reveal:not([data-cb-observed])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in-view'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); revealIO.unobserve(e.target); } });
      }, { threshold: 0.15 });
    }
    els.forEach(function (el) { el.setAttribute('data-cb-observed', '1'); revealIO.observe(el); });
  }

  function setupSticky() {
    var sticky = document.querySelector('.cb-sticky');
    if (!sticky) return;
    var mode = sticky.getAttribute('data-show') || 'after-hero';
    var trigger = document.querySelector('[data-cb-sticky-trigger]') || document.querySelector('.cb-hero');
    if (heroIO) { heroIO.disconnect(); heroIO = null; }
    if (mode === 'always' || !trigger || !('IntersectionObserver' in window)) { sticky.classList.add('show'); return; }
    heroIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    heroIO.observe(trigger);
  }

  function refresh() { setupReveal(); setupSticky(); }
  window.__cbLandingRefresh = refresh;

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', refresh); } else { refresh(); }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
})();
